export default "__VITE_ASSET__DMXTz8WP__"